import { reportStatus } from '@/enums/reportStatus'
import BaseService from '@/services/baseService'

export default class PodiumMetaXploreReportService extends BaseService {
  static async getReports(
    states = [reportStatus.GENERATED],
    noOfReports = 100,
    products = ['MetaXplore'],
    page = 1,
    sortBy = 'id',
    sortDirection = 'DESC',
    keyword = ''
  ) {
    const reportsResponse = await super.callStore('getReportsFromPodium', {
      states,
      noOfReports,
      products,
      page,
      sortBy,
      sortDirection,
      keyword
    })

    return reportsResponse.data
  }

  static async getReportSummary(resultId) {
    if (!resultId) throw new Error('Missing resultId.')

    const summaryResponse = await super.callStore('getReportSummary', { resultId })

    return summaryResponse.data
  }
}
